import { Injectable } from '@angular/core';
import { SnotifyPosition, SnotifyService, SnotifyToast, SnotifyToastConfig } from 'ng-snotify';
import { Observable } from 'rxjs/Observable';

/**
 * 通知トースト管理サービス
 */
@Injectable()
export class NotifyToastService {
  constructor(
    private snotify: SnotifyService
  ) {}

  /**
   * 確定保存 保存完了通知トースト表示
   */
  notifySaveCompleted(): Observable<SnotifyToast> {
    return new Observable(subscriber => {
      const config: SnotifyToastConfig = {
        timeout: 2000,
        pauseOnHover: false,
        backdrop: 0.5,
        showProgressBar: false,
        icon: 'assets/images/icon_leaf_check.png',
        position: SnotifyPosition.centerCenter
      };
      // なぜか`hidden`イベントは返ってこないので、やむなく`beforeHide`を使う
      const t = this.snotify.simple('保存が完了しました', config);
      t.on('beforeHide', (toast) => {
        subscriber.next(toast);
        subscriber.complete();
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/notify-toast/notify-toast.service.ts